import { Themes } from "thorium-ui";
const customThemes = { ...Themes };

customThemes.dark.body["background-color"] = "#000000";
customThemes.light.body["background-color"] = "#ffffff";
customThemes.dark.body["font-size"] = "1.2em";
customThemes.light.body["font-size"] = "1.2em";
customThemes.dark.body["font-weight"] = "400";
customThemes.light.body["font-wight"] = "500";

export default customThemes;
